/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';

export default function HtmlViewer({ html, className }) {
  return html ? <div className={className} dangerouslySetInnerHTML={{ __html: html }} /> : null;
}

HtmlViewer.propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string,
};

HtmlViewer.defaultProps = {
  className: '',
};
